import './NavBar.css'
import { NavLink } from 'react-router-dom';
import logo from '../logo.png'
import { useAuth } from '../context/AuthContext';
import UserMenu from "./UserMenu";

const NavBar = () => {
  const inactiveLinkClasses = "text-crumbblue hover:bg-gray-100 px-3 py-1.5 rounded-full font-medium transition";
  const activeLinkClasses = "text-white bg-crumbblue px-3 py-1.5 rounded-full font-medium";
  const { isAuthenticated } = useAuth();

  return (
    <nav id="navBar" className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <NavLink to="/">
            <div className="flex-shrink-0">
              <img src={logo} className="LandingPage-logo" alt="logo" />
            </div>
          </NavLink>
          { isAuthenticated?
              <div className="flex space-x-6">
                  <NavLink
                      to="/dashboard"
                      className={({ isActive }) =>
                          isActive ? activeLinkClasses : inactiveLinkClasses
                      }
                  >
                      Home
                  </NavLink>
                  <NavLink
                      to="/clients"
                      className={({ isActive }) =>
                          isActive ? activeLinkClasses : inactiveLinkClasses
                      }
                  >
                      Clients
                  </NavLink>
                  <NavLink
                      to="/follow-ups"
                      className={({ isActive }) =>
                          isActive ? activeLinkClasses : inactiveLinkClasses
                      }
                  >
                      Follow-Ups
                  </NavLink>
                <NavLink
                    to="/calendar"
                    className={({ isActive }) =>
                        isActive ? activeLinkClasses : inactiveLinkClasses
                    }
                >
                  Calendar
                </NavLink>
                  <UserMenu />
              </div>
              :
            <div className="flex space-x-6">
              <NavLink
                to="/"
                className={({ isActive }) =>
                  isActive ? activeLinkClasses : inactiveLinkClasses
                }
              >
                Home
              </NavLink>
              <NavLink
                to="/login"
                className={({ isActive }) =>
                  isActive ? activeLinkClasses : inactiveLinkClasses
                }
              >
                Log in
              </NavLink>
              <NavLink
                to="/signup"
                className={({ isActive }) =>
                  isActive ? activeLinkClasses : inactiveLinkClasses
                }
              >
                Sign up
              </NavLink>
            </div>
          }
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
